<nb-layout>
  <nb-layout-column>
    <div *ngIf="responsiveMode === 'lg'"
         class="d-flex flex-column align-items-center justify-content-center position-relative error-500">
      <div class="m-auto py-5">
        <img src="assets/images/errors/error-500.png" alt="">
        <div class="d-flex flex-column align-items-center justify-content-between text-position ">
          <p class="main-text">خطای داخلی سرور</p>
          <p class="description">یک اتفاق غیرمنتظره در سرور رخ داده و سرور قادر نیست صفحه‌ای که شما درتلاش برای دستیابی
            به آن هستید را بارگزاری کند.
            <br/>
            برای رفع مشکل با پشتیبانی ارتباط بگیرید.
          </p>
          <p class="info">خطای ۵۰۰</p>
          <div class="button-action action-link" *ngIf="supporterContactInfo.contactInfoType === 'Email'">
            <a href="mailto:{{supporterContactInfo.email}}">
              راه ارتباطی با پشتیبانی:
              <br/>
              {{supporterContactInfo.email}}
            </a>
          </div>
          <div class="button-action action-link" *ngIf="supporterContactInfo.contactInfoType === 'PhoneNumber'">
              راه ارتباطی با پشتیبانی:
              <br/>
              {{supporterContactInfo.phoneNumber}}
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="responsiveMode === 'md'" class="m-auto">
      <img src="assets/images/errors/error-500.png" alt="">
      <div class="d-flex flex-column align-items-center justify-content-between">
        <p class="main-text">خطای داخلی سرور</p>
        <p class="description">یک اتفاق غیرمنتظره در سرور رخ داده و سرور قادر نیست صفحه‌ای که شما درتلاش برای دستیابی به
          آن
          هستید را بارگزاری کند.</p>
        <p class="info">خطای ۵۰۰</p>
        <div class="button-action action-link" *ngIf="supporterContactInfo.contactInfoType === 'Email'">
          <a href="mailto:{{supporterContactInfo.email}}">
            راه ارتباطی با پشتیبانی:
            <br/>
            {{supporterContactInfo.email}}
          </a>
        </div>
        <div class="button-action action-link" *ngIf="supporterContactInfo.contactInfoType === 'PhoneNumber'">
            راه ارتباطی با پشتیبانی:
            <br/>
            {{supporterContactInfo.phoneNumber}}
        </div>
      </div>
    </div>
  </nb-layout-column>
</nb-layout>

